import { useEffect, useState } from "react";
import { useParams, useLocation, Navigate } from "react-router-dom";
import { api } from "../../lib/api";

// AIR12 Captain DELTA — authenticated shipment-code deep-link resolver. Resolves a public Shipment
// code (used in customer emails instead of an internal UUID) to its canonical id, then forwards to
// the standard shipment-detail route, preserving any query (e.g. ?focus=balance-payment).
// Auth is handled upstream by ProtectedShell/Login (?redirect=) — no magic links or tokens here.
export default function ShipmentByCode() {
  const { shipmentCode } = useParams();
  const location = useLocation();
  const [state, setState] = useState({ status: "loading", id: null });

  useEffect(() => {
    let alive = true;
    api.get(`/sender/shipments/by-code/${encodeURIComponent(shipmentCode)}`)
      .then((r) => { if (alive) setState({ status: "ok", id: r.data.id }); })
      .catch((e) => {
        if (!alive) return;
        setState({ status: e?.response?.status === 404 ? "notfound" : "error", id: null });
      });
    return () => { alive = false; };
  }, [shipmentCode]);

  if (state.status === "loading") {
    return <div className="p-10 mono text-sm" data-testid="shipment-by-code-loading">Opening shipment…</div>;
  }
  if (state.status === "ok") {
    return <Navigate to={`/sender/shipments/${state.id}${location.search}`} replace />;
  }
  if (state.status === "notfound") {
    return <div className="p-10 mono text-sm" data-testid="shipment-by-code-notfound">Shipment not found.</div>;
  }
  return <div className="p-10 mono text-sm" data-testid="shipment-by-code-error">Could not open this shipment. Please try again.</div>;
}
